import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { i18TranslationNS, Translation } from '@shared/config/i18n';

import s from './Loader.module.css';

// Clockwise order — each tile's sharp corner points to the center (Palary mark shape language)
const TILES = [s.tile_tl, s.tile_tr, s.tile_br, s.tile_bl];

export const Loader = ({ fullscreen = false, overlay = true, className = '' }) => {
	const { t } = useTranslation(i18TranslationNS);

	const labels = {
		loading: t(Translation.LOADER_LABEL),
	};

	return (
		<div
			className={clsx(
				s.loader,
				overlay && s.loader_overlay,
				fullscreen && s.loader_fullscreen,
				className,
			)}
			role='status'
			aria-live='polite'
		>
			<span className={s.mark} aria-hidden='true'>
				{TILES.map((tileClass) => (
					<span key={tileClass} className={clsx(s.tile, tileClass)} />
				))}
			</span>
			<span className='visually-hidden'>{labels.loading}</span>
		</div>
	);
};

export const FullscreenLoader = () => <Loader fullscreen />;
